import { useFormContext } from 'react-hook-form';

import { ui } from '../ui';

interface Props {
	name?: string;
}

const Firstname: React.FC<Props> = ({ name = 'first_name' }) => {
	const { control } = useFormContext();

	return (
		<ui.FormField
			control={control}
			name={name}
			data-cy={name}
			render={({ field }) => (
				<ui.FormItem>
					<ui.FormLabel>First Name</ui.FormLabel>
					<ui.FormControl>
						<ui.Input type="text" placeholder="e.g. Sherlock" {...field} />
					</ui.FormControl>
					<ui.FormMessage />
				</ui.FormItem>
			)}
		/>
	);
};

export default Firstname;
